import * as Routes from '@/modules/routes';

// AIDEV-NOTE: Staff reach the teacher's pages by masquerading, and Grade Sync refuses the impersonated
// teacher, so this ends the masquerade first (Admin::MasqueradesController#back with a to_path) and
// lands on the assignment as the real staff member. return_to is the current page, so the dashboard's
// "Return to <teacher>'s account" can start the masquerade again and come back here.
// AIDEV-NOTE: The legacy /admin/grade_sync mount, not /sysadmin: the SPA is Sysadmin-only, and support
// managers masquerade and follow these links too.
const gradeSyncUrl = (assignmentId: number) => {
  const returnTo = encodeURIComponent(`${window.location.pathname}${window.location.search}`);

  return Routes.back_staffer_masquerade_index_path({
    to_path: `${Routes.admin_grade_sync_index_path()}/assignments/${assignmentId}?return_to=${returnTo}`,
  });
};

export default gradeSyncUrl;
